<template>
  <div class="item">
    <div class="item-header">
      <div class="item-header-title">DIGITAL TRANSFORMATION SOLUTIONS</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>数字化转型</span>
        <span class="bold">解决方案</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">值得信赖的专业数据中心技术服务提供商。</div>
    </div>

    <div class="item-content">
      <div class="scroll">
        <div :class="getLeftClasses" @click="prevSolution" />
        <div class="scroll-content">
          <div class="scroll-wrap" :style="getWrapStyle">
            <div class="scroll-items" v-for="(child,i) in list" :key="`child-${i}`">
              <div class="scroll-item" v-for="(item,j) in child" :key="`${i}-${j}`">
                <div class="image">
                  <img :src="item.img" />
                </div>
                <div class="scroll-item-content">
                  <span class="scroll-item-name">{{item.desc}}</span>
                  <div class="scroll-item-btn" @click="handleClick(i)">详细了解</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="getRightClasses" @click="nextSolution" />
      </div>
    </div>
  </div>
</template>

<script>
import IMAGE_SOLUTION from '../../assets/images/solution.png'
import { getSolutionData } from '../../services'

export default {
  data () {
    return {
      IMAGE_SOLUTION,
      solutionPage: 0,
      list: []
    }
  },

  created () {
    getSolutionData().then(res => {
      let list = []
      res.data.data.data.children.forEach((item, i) => {
        const page = Math.floor(i / 4)
        const index = i % 4
        if (!list[page]) {
          list[page] = []
        }
        list[page][index] = {
          img: 'http://tarzan.minus.live' + item.img,
          desc: item.desc
        }
      })
      this.list = list
    })
  },

  methods: {
    showBoard () {
      window.eventBus.$emit('boardShow')
    },

    handleClick (i) {
      this.$router.push(`/solution${i + 1}`)
    },

    nextSolution () {
      if (this.solutionPage <= this.list.length - 2) {
        this.solutionPage += 1
      }
    },

    prevSolution () {
      if (this.solutionPage > 0) {
        this.solutionPage -= 1
      }
    },

    getWidth () {
      let translateX = 640
      const width = document.body.getBoundingClientRect().width
      if (width > 1280 && width <= 1680) {
        translateX = 960
      } else if (width >= 1920) {
        translateX = 1280
      }
      return translateX
    }
  },

  computed: {
    getSolutionScrollItemsStyle () {
      let translateX = this.getWidth()

      return {
        transform: `translateX(${this.solutionPage * -translateX}px)`
      }
    },

    getWrapStyle () {
      const translateX = this.getWidth()
      return {
        width: translateX * this.list.length + 'px',
        transform: `translateX(${this.solutionPage * -translateX}px)`
      }
    },

    getLeftClasses () {
      return `scroll-btn scroll-left ${this.solutionPage === 0 ? '' : 'active'}`
    },

    getRightClasses () {
      return `scroll-btn scroll-right ${this.solutionPage === this.list.length - 1 ? '' : 'active'}`
    }
  }
}
</script>

<style lang="less" scoped>
.scroll {
    display: flex;
    align-items: center;
    &-btn {
      width: 30px;
      height: 30px;
      cursor: pointer;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 45px;
        height: 45px;
      }
      
      @media screen and (min-width: 1920px){
        width: 60px;
        height: 60px;
      }
    }
    &-left {
      background: url('../../assets/images/left_arrow.png');
      background-size: 100% 100%;
    }
    &-right {
      background: url('../../assets/images/right_arrow.png');
      background-size: 100% 100%;
    }
    &-left.active {
      background: url('../../assets/images/left_arrow_active.png');
      background-size: 100% 100%;
    }
    &-right.active {
      background: url('../../assets/images/right_arrow_active.png');
      background-size: 100% 100%;
    }
    &-content {
      width: 640px;
      margin: 0 20px;
      overflow: hidden;
      @media (min-width: 1280px) and (max-width: 1680px){
        width: 960px;
        margin: 0 30px;
      }
            
      @media screen and (min-width: 1920px){
        width: 1280px;
        margin: 0 40px;
      }
      .scroll-wrap {
        display: flex;
        transition: all .5s ease-in-out;
      }

      .scroll-items {
        width: 640px;
        display: flex;
        transition: all .5s ease-in-out;
        @media (min-width: 1280px) and (max-width: 1680px){
          width: 960px;
        }
              
        @media screen and (min-width: 1920px){
          width: 1280px;
        }

        .scroll-item:hover {
          img {
            width: 150%;
            height: 150%;
          }
        }

        .scroll-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          width: 150px;
          height: 250px;
          margin: 0 5px;
          transition: all .5s ease-in-out;

          @media (min-width: 1280px) and (max-width: 1680px){
            width: 225px;
            height: 375px;
            margin: 0 7.5px;
            border-width: 1.5px;
          }
                
          @media screen and (min-width: 1920px){
            width: 300px;
            height: 500px;
            margin: 0 10px;
            border-width: 2px;
          }

          .image {
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .image, img {
            width: 100%;
            height: 100%;
            transition: all .5s ease-in-out;

            // @media (min-width: 1280px) and (max-width: 1680px){
            //   width: 225px;
            //   height: 225px;
            // }
                  
            // @media screen and (min-width: 1920px){
            //   width: 300px;
            //   height: 300px;
            // }
          }

          &-content {
            background: rgba(0, 0, 0, .5);
            position: absolute;
            bottom: 0px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
          }

          &-name {
            font-size: 12px;
            color: #fff;
            transition: all .5s ease-in-out;
            margin-top: 16px;

            @media (min-width: 1280px) and (max-width: 1680px){
              font-size: 18px;
              margin-top: 30px;
            }
                  
            @media screen and (min-width: 1920px){
              font-size: 24px;
              margin-top: 40px;
            }
          }

          &-btn {
            width: 96px;
            height: 28px;
            border-radius: 14px;
            background-color: #f45937;
            color: #fff;
            font-size: 9px;
            line-height: 28px;
            text-align: center;
            transition: all .5s ease-in-out;
            margin: 16px 0px;
            cursor: pointer;

            @media (min-width: 1280px) and (max-width: 1680px){
              width: 144px;
              height: 42px;
              border-radius: 21px;
              font-size: 14px;
              line-height: 42px;
              margin-top: 30px;
            }
                  
            @media screen and (min-width: 1920px){
              width: 192px;
              height: 56px;
              border-radius: 28px;
              font-size: 18px;
              line-height: 56px;
              margin-top: 40px;
            }
          }
        }
      }
    }
  }
</style>